import React, { Component } from 'react';
import { Spin, Table, Row, Button, Input, Divider, Popconfirm } from 'antd';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import { PopUpForm } from '../../../lib/ui/popupform';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import ErrorWrapper from '../../../lib/error_wrapper';

import { showErrorInNotification, overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';

const queryString = require('query-string');

const services_schema = [
    {
        index: "name",
        name: "Name",
        type: 'text'
    },
    // {
    //     index: 'description',
    //     name: "Description",
    //     type: 'textarea'
    // }, 
    // {
    //     index: 'color_code',
    //     name: "Color Code",
    //     type: 'color_picker'
    // }, 
    // {
    //     index: 'fields_config',
    //     name: "Field Config",
    //     type: 'json'
    // }
];

const services_cols = ({ onEditPressed, onDeletePressed ,datatype_id}) => [
    {
        title: "Name",
        dataIndex: "name",
        key: "name"
    },
    //  {
    //     title: "Color Code",
    //     dataIndex: "color_code",
    //     key: 'color_code',
    //     render: (color) => {
    //         return <div style={{
    //             height: 12,
    //             width: 12,
    //             borderRadius: 6,
    //             backgroundColor: color
    //         }}></div>
    //     }

    // }, 
    {
        title: "Actions",
        dataIndex: 'id',
        key: 'action',
        width: 200,
        className:'center-align',
        render: (id, data) => {
            return <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center'
            }}>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                    onClick={() => {
                        typeof onEditPressed === 'function' && onEditPressed(id, data);
                    }}>Edit</Button>
                      <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${datatype_id}/services/${id}/enrichers`}>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                   >Enrichers</Button>
                    </Link>
                <Divider type='vertical' />
                <Link to={`/settings/groups/datatype/${datatype_id}/services/${id}/extractors`}>
                <Button
                    type='link'
                    style={{ padding: 0 }}
                   >Extractors</Button>
                    </Link>
                <Divider type='vertical' />
                <Popconfirm title={"Are you sure you want to delete?"} onConfirm={() => {
                    typeof onDeletePressed === 'function' && onDeletePressed(id, data);
                }} >
                    <Button
                        type='link'
                        style={{ padding: 0, color: 'red' }}
                    >Delete</Button>
                </Popconfirm>
            </div>
        }
    }
];

class DataServicesList extends Component {
    constructor(props) {
        super(props)

        this.datatype_id = props.match.params.datatype_id;
        this.state = {
            filter_query: {
                per_page: 100,
                page: 1
            },
            form_data: {},
            edit_id: null,
            form_visibility: false
        };



        this.list_services = RESTExecutor
            .list()
            .config({
                label: 'services_list',
                params: {
                    ...this.state.filter_query
                }
            }).forId(this.datatype_id)
            .callbacks((success)=>{},(error)=>{
                showErrorInNotification(error)
            })
            .connect(props.domains.datatype);

        this.post_services = RESTExecutor.post().config({
            label: 'services_list'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_services.execute()
            })
            .connect(props.domains.datatype);

        this.patch_services = RESTExecutor.patch().config({
            label: 'services_detail',
            params: {
                datatype_id: "",
                service_id: ""
            }
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_services.execute()
            })
            .connect(props.domains.datatype);

        this.delete_services = RESTExecutor.delete().config({
            label: 'services_detail',
            params: {
                datatype_id: "",
                service_id: ""
            }
        })
            .callbacks((success) => {
                this.list_services.execute()
            })
            .connect(props.domains.datatype);


        // this.list_services.execute()

        this.delay_search=new NetworkDelaySearch();


    }
    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            this.patch_services.config({
                params: {
                    datatype_id: this.datatype_id,
                    service_id: this.state.edit_id
                }
            }).execute(data);
        } else {
            this.post_services.forId(this.datatype_id).execute(data);
        }
    }

    deleteService = (id) => {
        this.delete_services.config({
            params: {
                datatype_id: this.datatype_id,
                service_id: id
            }
        }).execute();
    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }

    render() {
        const { filter_query } = this.state;
        let list_services_resp = this.list_services.response();
        let post_services_resp = this.post_services.response();
        let patch_services_resp = this.patch_services.response();

        let rowsData = (list_services_resp.result && list_services_resp.result.rows) || [];
        let rowsMeta = list_services_resp.meta || {};

        return (
            <div>
             <BasicHeader  title="Services"
                    right={[
                        <TransparentButton
                            label="Add New"
                            hint="Add New Datatype"
                            onClick={() => {
                                this.setState({
                                    edit_id: null,
                                    form_data: {},
                                    form_visibility: true
                                })
                            }}

                        />,
                    ]}

                />
                <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                        <Input.Search
                        allowClear
                            autoFocus
                                placeholder="Search For"
                                style={{
                                }}
                                value={filter_query.query}
                                onChange={(e) => {
                                    this.stateUpdater({ stateKey: 'filter_query', valueKey: 'query', value: e.target.value,callback:()=>{
                                        this.delay_search.onSearch(()=>{
                                            this.props.history.push({
                                                // pathname:"users",
                                                search:queryString.stringify({...this.state.filter_query,per_page:100,page:1})
                                            })
                                        })
                                    } })
                                }}/> 
                    
                    </div></div>
                
            <ErrorWrapper
            error={list_services_resp}
            onReload={()=>{
                this.list_services.forId(this.datatype_id).execute()
            }}
            >
            <div
                className='default-card'
                style={{
                    padding: 0
                }}>
                {/* <CustomHeader /> */}

                <Table // rowClassName='hand-cursor'
                    className='main-table'
                    loading={list_services_resp.fetching}
                    size='small'
                    scroll={{x:true}}
                    pagination={{
                        simple: false,
                            position:'bottom',
                        onChange: (current, size) => {
                            this.props.history.push({
                                // pathname:"users",
                                search:queryString.stringify({...this.state.filter_query,per_page:size,page:current})
                            })
                        },
                        defaultCurrent: 1,
                        current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                        pageSize: (rowsMeta && rowsMeta.requested_count),
                        total: (rowsMeta && rowsMeta.total_count),
                        showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                    }} 
                    
                    rowKey={(record) => record.id} columns={services_cols({
                        onDeletePressed: (id, data) => {
                            this.deleteService(id)
                        },
                        onEditPressed: (id, data) => {
                            this.setState({
                                edit_id: id,
                                form_data: data,
                                form_visibility: true
                            })

                        },
                        datatype_id:this.datatype_id

                    })} dataSource={rowsData} />


            </div>
            </ErrorWrapper>
           
            <PopUpForm
                    title={"Data Services"}
                    forCreate={this.state.edit_id
                        ? false
                        : true}
                    initialData={this.state.form_data}
                    fields={services_schema}
                    open={this.state.form_visibility}
                    networkState={this.state.edit_id
                        ? patch_services_resp
                        : post_services_resp}
                    onClose={() => this.setState({ form_visibility: false })}
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        this.handlePostPatch(data);
                    }} />
            </div>

        );
    }

    // componentDidMount(){
    //     try{
    //         window.header_assigner.assignTitle("Service List");
    
    //     }catch(e){}
    // }
    componentDidMount(){
        overrideHeaderBack('back');
        overrideHeaderTitle("Service List");
        let new_filter_query={};
        if(this.props.location&&this.props.location.search){
        const parsed = queryString.parse(this.props.location.search);
        new_filter_query=parsed;
        }
        this.setState({
        filter_query:{
            per_page:100,
            page:1,
            ...new_filter_query
        }
        },()=>{
        this.list_services.config({
            params: {
            ...this.state.filter_query
            }
        }).execute()
        })
    }
    componentWillUnmount(){
        overrideHeaderBack(null)
    }

    componentWillReceiveProps (nextProps) {
        var olddatatype_id = this.props.match.params.datatype_id;
        var newdatatype_id = nextProps.match.params.datatype_id;


        if(olddatatype_id!==newdatatype_id || (
          this.props.location&&(this.props.location.search!==nextProps.location.search)
        )){
            this.datatype_id=newdatatype_id;
            const parsed = queryString.parse(nextProps.location.search);
            this.setState({
                filter_query:{
                    per_page:100,
                    page:1,
                    ...parsed
                }
                },()=>{
                this.list_services.forId(this.datatype_id).config({
                    params: {
                    ...this.state.filter_query
                    }
                }).execute()
                })
    
        }
    }
}

export default withDomains(DataServicesList, "datatype");
